module.exports = __webpack_public_path__ + "img/banner-web.e44e3c44.jpg";